/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Fast Inquiry Create Buttons component
 *
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.36.0
 */

import { FC } from 'react';

import { Button } from '@nexign/scc-ui-kit';

import { LinkBlock } from '@/main/components/common';
import { TableFooterFastActionsButtonsStyled } from '@/main/components/common/TableFooter';
import ArrowTooltip from '@/main/components/common/Tooltip/Tooltip';
import { EOnboardingComponentsId } from '@/main/modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '@/main/modules/role/constants/guard/guardConstants';
import { RoutePath } from '@/main/routes/constants/routesConstants';

interface IFastInquiryCreateButtonsProps {
    inquiryCreate: {
        onClick: () => void;
        fastInquiryCreateTitle?: string;
        text: string;
        tooltipMsg: string;
        onboarding?: EOnboardingComponentsId | undefined;
        className: string;
        dataName: string;
        icon: string;
        id: AccessComponentKeyEnum;
    };
    isDisabled: boolean;
    tooltipMsg: string;
    cancelButtonText: string;
}



export const FastInquiryCreateButtons: FC<IFastInquiryCreateButtonsProps> = (
    { inquiryCreate, isDisabled, tooltipMsg, cancelButtonText },
) => {
    return (
        <TableFooterFastActionsButtonsStyled>
            <ArrowTooltip
                // Tooltip is displayed when the button is locked
                disableHoverListener={!tooltipMsg || !isDisabled}
                key={inquiryCreate.text}
                placement="top"
                title={tooltipMsg}
                titleAlign="center"
            >
                <div>
                    <Button
                        className={inquiryCreate.className}
                        dataName={inquiryCreate.dataName}
                        disabled={isDisabled}
                        kind="mediumNormal"
                        onClick={inquiryCreate.onClick} 
                    >
                        {inquiryCreate.fastInquiryCreateTitle || inquiryCreate.text}
                    </Button>
                </div>
            </ArrowTooltip>
            <LinkBlock dataName="redirectToDashboard" url={RoutePath.dashboard}>
                {cancelButtonText}
            </LinkBlock>
        </TableFooterFastActionsButtonsStyled>
    )};
